import { useStytchB2BClient, useStytchMemberSession } from '@stytch/react/b2b';
import { useEffect } from 'react';
import { FullScreenSpinner } from 'smoothie';

import { useUpdateAdminUserEntraToken } from '../../admin-users/hooks/useUpdateAdminUserEntraToken';
import { captureException, captureMessage } from '../../logger/Logger';
import { SESSION_DURATION_MINUTES } from '../authConstants';

// https://stytch.com/docs/b2b/sdks/javascript-sdk/oauth#authenticate
export default function OAuthHandler() {
    const stytchClient = useStytchB2BClient();
    const { session } = useStytchMemberSession();
    const { mutateAsync: updateEntraToken } = useUpdateAdminUserEntraToken();

    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get('token');

        if (token == null) {
            return;
        }

        void (async () => {
            try {
                const response = await stytchClient.oauth.authenticate({
                    oauth_token: token,
                    session_duration_minutes: SESSION_DURATION_MINUTES,
                });
                const idToken = response.provider_values.id_token;
                if (idToken === '' || !response.member_authenticated) {
                    captureMessage(
                        'OAuth authenticate missing Entra id_token or member_authenticated; skipping entra-token sync.',
                    );
                    return;
                }

                await updateEntraToken({ body: { idToken } });
            } catch (error) {
                captureException(error);
            }
        })();
    }, [stytchClient, session, updateEntraToken]);

    return <FullScreenSpinner />;
}
